import type { InventoryEntry } from "@idle-rpg/shared";

export function stackedValue(entry: InventoryEntry): number {
  const unitValue = entry.referencePrice?.price ?? entry.item?.basePrice ?? 0;
  const qty = entry.quantity ?? 0;
  return Math.max(0, unitValue) * Math.max(0, qty);
}

export function compareEntriesByStackedValue(a: InventoryEntry, b: InventoryEntry): number {
  const valueDiff = stackedValue(b) - stackedValue(a);
  if (valueDiff !== 0) return valueDiff;
  const nameA = (a.item?.name || a.itemId || "").toLowerCase();
  const nameB = (b.item?.name || b.itemId || "").toLowerCase();
  const nameDiff = nameA.localeCompare(nameB);
  if (nameDiff !== 0) return nameDiff;
  const idDiff = a.itemId.localeCompare(b.itemId);
  if (idDiff !== 0) return idDiff;
  const variantDiff = (a.variantKey ?? "").localeCompare(b.variantKey ?? "");
  if (variantDiff !== 0) return variantDiff;
  const enchantDiff = (a.enchantment?.id ?? "").localeCompare(b.enchantment?.id ?? "");
  if (enchantDiff !== 0) return enchantDiff;
  return (a.instanceIds?.[0] ?? "").localeCompare(b.instanceIds?.[0] ?? "");
}
